module.exports = __webpack_public_path__ + "static/media/user.affa8721.svg";